import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74d0927b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "taglist" }
const _hoisted_2 = { class: "searchlist" }
const _hoisted_3 = {
  key: 0,
  class: "history"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "历史搜索", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["searchStockSelectwrap", _ctx.theme]),
    style: _normalizeStyle({'padding-right': _ctx.tags.length ? '140px': '34px', cursor: _ctx.tags.length > 4 ? 'not-allowed' : 'text'}),
    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handlefocusInput && _ctx.handlefocusInput(...args)))
  }, [
    _createElementVNode("div", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handlefocusInput && _ctx.handlefocusInput(...args)))
    }, [
      _withDirectives(_createElementVNode("span", { class: "selectedNum" }, "已选择" + _toDisplayString(_ctx.tags.length) + " /5项", 513), [
        [_vShow, _ctx.tags.length]
      ]),
      _createVNode(_component_a_button, {
        class: "handlesearch",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickButton($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SearchOutlined)
        ]),
        _: 1
      }),
      _createElementVNode("section", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (item) => {
          return (_openBlock(), _createBlock(_component_a_tag, {
            key: item.Id,
            closable: "",
            onClose: ($event: any) => (_ctx.deletetag(item.Id))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.Code), 1)
            ]),
            _: 2
          }, 1032, ["onClose"]))
        }), 128))
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["placeholder", {'hideWord': _ctx.value.length || _ctx.tags.length}]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlefocusInput && _ctx.handlefocusInput(...args)))
      }, _toDisplayString(!_ctx.value.length && !_ctx.tags.length ? _ctx.placeholder : _ctx.value), 3),
      _createVNode(_component_a_input, {
        ref: "askingselect",
        id: "askingInput",
        disabled: _ctx.tags.length > 4,
        value: _ctx.value,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event)),
        style: _normalizeStyle({width: _ctx.width}),
        onFocus: _ctx.focusSelect,
        onBlur: _ctx.blurSelect,
        onKeydown: _ctx.setWidth,
        onKeyup: _ctx.inputKeyup,
        onChange: _ctx.searchValue
      }, null, 8, ["disabled", "value", "style", "onFocus", "onBlur", "onKeydown", "onKeyup", "onChange"])
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_2, [
      _createElementVNode("ul", {
        onKeydown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handlekeyFn($event)))
      }, [
        (_ctx.searchstr === '' && (_ctx.historyOption||[]).length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearHistory && _ctx.clearHistory(...args)))
              }, [
                _createVNode(_component_DeleteOutlined)
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOption, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.Id,
            class: _normalizeClass({'active': _ctx.activeLi === item.Id}),
            onClick: ($event: any) => (_ctx.handleChange($event, item))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.Code), 1),
            _createElementVNode("span", {
              title: item.Name
            }, _toDisplayString(item.Name), 9, _hoisted_6),
            _createElementVNode("span", null, _toDisplayString(item.MarketCode==='sh' ? '沪A' : item.MarketCode==='sz' ? '深A' : ''), 1)
          ], 10, _hoisted_5))
        }), 128))
      ], 32)
    ], 512), [
      [_vShow, _ctx.selectOption.length && _ctx.showDropdown]
    ])
  ], 6))
}